import { jsx } from '@emotion/react';
import { Redirect } from 'react-router-dom';

import { connectOrder } from './BYRConnectors.jsx';
import CONFIGURATIONS, { loadVariantFromStore } from './steps_config';
// eslint-disable-next-line import/no-cycle -- utilities imports back from here
import { Step } from './utilities';
import { canUseDOM } from '../helpers/dom';
import { connectLocation } from '../location/LocationConnectors';

// This file is responsible for all step-ordering UI.
// The step data and pure ordering helpers live in steps_config.js so non-UI
// consumers (reducers, analytics) can use them without pulling this module in.

export { StepSetup, CustomizeStepSetup, StepConfiguration, getNextStep, getPrevStep } from './steps_config';

export const XInitialRedirector = ({ stepOrder }) => {
  // QueryParams

  if (!stepOrder) return null;
  // window.location.search is set to preserve queryparams
  const search = canUseDOM() ? window.location.search : '';
  return <Redirect to={CONFIGURATIONS[stepOrder][0].path + search} />;
};

export const InitialRedirector = connectOrder(XInitialRedirector);

export const XOrderedMenuItems = ({ t, stylesheets, variant = loadVariantFromStore() }) => (
  <ul css={stylesheets.menu_navigation}>
    {CONFIGURATIONS[variant].map((step, idx) => (
      <li css={idx === CONFIGURATIONS[variant].length - 1 && stylesheets.mobileOnly}>
        <Step path={step.path} step={idx + 1} title={t(step.title)} />
      </li>
    ))}
  </ul>
);

export const OrderedMenuItems = connectLocation(XOrderedMenuItems);
